export default __webpack_public_path__ + "static/media/stmichael.12900411.jpg";